<template>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.43536 2.01184V4.90301H9.32653V2.01184H6.43536ZM12.2177 7.79417V4.90301H9.32653V7.79417H12.2177ZM15.1089 10.6853V7.79417H12.2177V10.6853H15.1089ZM15.1089 13.5765H18V10.6853H15.1089V13.5765ZM12.2177 16.4677V13.5765H15.1089V16.4677H12.2177ZM12.2177 16.4677H9.32653V19.3588H12.2177V16.4677ZM6.43536 22.25V19.3588H9.32653V22.25H6.43536Z" fill="currentColor"/>
    </svg>
</template>
